export const currencyFormat = (currency) => {
  const nf = Intl.NumberFormat();
  const num = currency;
  return nf.format(num);
};
